<template>
    <div>
        <div class=" pt-0  text-center">
            <div>
                Bản quyền thuộc công ty CPĐT Vega Fintech
            </div>
            <div>
                Địa chỉ: Tầng 3, tòa nhà Hòa Bình, 106 Hoàng Quốc Việt, Cầu Giấy, Hà Nội
            </div>
            <div>
                MST: 0107815397
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    data(){
        return {
            baseURL: window.location.origin
        }
    },
    methods: {
        toBlog(){
            this.$router.push('/blog')
        }
    }
}
</script>

<style>
.mg-t20{
    margin-top: 20px;
}

.footer_address {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 142%;
    letter-spacing: -0.03em;
    color: #717981;
    margin-top: 30px;
    margin-bottom: 20px;
}
</style>